import {
    GET_CONFIG_FORM97,
    GET_COMPANIAS,
    GET_ORIGENES,
    GET_SITUACIONES_HONO,
    GET_CONSULTA_HONORARIOS,
    CLEAN_CASOS_HONORARIOS,
    SET_QUERY_STATE_HONORARIOS
} from '../types';


export default function solicitudHonorariosReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM97:
            return { ...state, cfg_form97:action.payload }
        case GET_COMPANIAS:
            return { ...state, companias:action.payload }
        case GET_ORIGENES:
            return { ...state, origenes:action.payload }
        case GET_SITUACIONES_HONO:
            return { ...state, situaciones:action.payload }
        case GET_CONSULTA_HONORARIOS:
            return { ...state, consultaHonorarios:action.payload }
        case CLEAN_CASOS_HONORARIOS:
            return { ...state, consultaHonorarios:{} }
        case SET_QUERY_STATE_HONORARIOS:
            return { ...state, myQueryStateGlobal:action.payload }       
        default:
            return state
    }
}